export * from './deviceDetect';
